import gql from 'graphql-tag'

export const LOGIN = gql`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      isSuccessful
      message
      data {
        token
        resource
        domainName
        payload
        canLogin
        statusCodeIdentity
      }
    }
  }
`

export const GET_AUTH = gql`
  query Auth {
    auth {
      isSuccessful
      message
      auth {
        isAdmin
        access
        fullname
        company {
          domainName
          name
        }
        groups {
          mgroupId
          vgroups {
            id
            name
          }
        }
      }
    }
  }
`

export const WHOAMI = gql`
  query Whoami {
    whoami {
      whoami {
        accessRight
        accessType
        companyId
        companyName
        companyParentId
        email
        isWhitelabel
        name
        userId
        scopes
        wsToken
        companyParentId
        isMetrack
        domainName
        onboardingNotifData {
          onboardingNotif
          setupNotifCompleted
        }
      }
    }
  }
`

export const LOGOUT = gql`
  mutation Logout {
    logout {
      isSuccessful
    }
  }
`

export const EMAIL_TO = gql`
  mutation EmailForgotPassword($input: EmailForgotPasswordInput) {
    emailForgotPassword(input: $input) {
      isSuccessful
      message
      emailForgotPassword {
        message
      }
    }
  }
`

export const OTP_CHECK = gql`
  mutation CheckingOtpPassword($input: CheckingOtpPasswordInput) {
    checkingOtpPassword(input: $input) {
      isSuccessful
      message
      checkingOtpPassword {
        message
      }
    }
  }
`

export const RESET_PASSWORD = gql`
  mutation ResetPasswordOtp($input: ResetPasswordOtpInput) {
    resetPasswordOtp(input: $input) {
      isSuccessful
      message
      resetPasswordOtp {
        message
        users {
          companyName
          fullname
          email
          accessRight
          userId
        }
      }
    }
  }
`

export const GET_PAYLOAD = gql`
  query GetPayload($filter: GetPayloadInput) {
    getPayload(filter: $filter) {
      isSuccessful
      message
      payload {
        payload
        subscribedAlertRules
      }
    }
  }
`

export const VSMS_V1 = gql`
  mutation BackToVsmsV1($input: BackToVsmsV1Input!) {
    backToVsmsV1(input: $input) {
      isSuccessful
      message
      backToVsmsV1 {
        message
      }
    }
  }
`

export const GENERATE_TEMPORARY_ACCESS = gql`
  mutation GenerateTemporaryAccess($input: GenerateTemporaryAccessInput!) {
    generateTemporaryAccess(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      generateTemporaryAccess {
        token
        url
      }
    }
  }
`

export const CREATE_USER_METADATA = gql`
  mutation CreateUserMetadata($input: CreateUserMetadataInput!) {
    createUserMetadata(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      createUserMetadata {
        acquiredOn
        userId
      }
    }
  }
`
